import Checkbox from '@sdk/components/forms/Checkbox';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import gettext from '@sdk/lang/gettext';

import { SubtaskInstance } from '@web/shiftTasks/types/SubtaskIntance';
import { ScrollContainer } from '@web/shiftTasks/ComposeTask/Subtasks/subtasks.styles';
import { TaskStatuses } from '@web/shiftTasks/types/TaskStatuses';
import { Value as SubtaskTitle } from '@web/components/NotificationModal/notificationModalRow.styles';
import { useUpdateSubtaskStatus } from '@web/shiftTasks/hooks/useUpdateSubtaskStatus';

import { SubtaskContainer, SubtasksContainer } from './subtasks.styles';

type Props = {
  taskId: ID;
  subtasks: SubtaskInstance[];
  isDisabled: boolean;
  onCompleteSubtask: VoidFunction;
};

export const SubtasksInstance = ({ taskId, subtasks, isDisabled, onCompleteSubtask }: Props) => {
  const { mutate } = useUpdateSubtaskStatus(taskId, onCompleteSubtask);
  const onClick = (subtask: SubtaskInstance, isSubtaskDone: boolean) => {
    const status = isSubtaskDone ? TaskStatuses.DONE : TaskStatuses.PENDING;
    mutate({ subtask, status });
  };

  return (
    <ScrollContainer>
      <SubtasksContainer isDisabled={isDisabled}>
        {subtasks.map((subtask) => (
          <SubtaskContainer key={subtask.id} data-for="disabled-subtasks-tooltip" data-tip="">
            <Checkbox
              value={subtask.status === TaskStatuses.DONE}
              disabled={isDisabled}
              onChange={(value) => {
                onClick(subtask, value);
              }}
            />
            <SubtaskTitle>{subtask.title}</SubtaskTitle>
          </SubtaskContainer>
        ))}
      </SubtasksContainer>

      <Tooltip id="disabled-subtasks-tooltip" key={taskId} attachToBody>
        {isDisabled ? gettext(`To update a subtask's status, reopen the task.`) : ''}
      </Tooltip>
    </ScrollContainer>
  );
};
